export default {
    SET_CUSTOMERS(state, { concatResults, customers }) {
        if (concatResults) {
            state.customers.items = [
                ...state.customers.items,
                ...customers.items
            ]
        } else {
            state.customers = customers
        }
    },
    SET_CUSTOMER_INFOS(state, customerInfos) {
        state.customerInfos = customerInfos
    },
    ADD_CUSTOMER(state, customer) {
        state.customers.items.unshift(customer)
    },
    UPDATE_CUSTOMER(state, customer) {
        const customerIndex = state.customers.items.findIndex((c) => c.id === customer.id)
        Object.assign(state.customers.items[customerIndex], customer)
    },
    DELETE_CUSTOMER(state, customerId) {
        const ItemIndex = state.customers.items.findIndex((c) => c.id === customerId)
        state.customers.items.splice(ItemIndex, 1)
    },
    SOFT_DELETE_CUSTOMER(state, customerId) {
        const ItemIndex = state.customers.items.findIndex((c) => c.id === customerId)
        state.customers.items.splice(ItemIndex, 1)
    }
}
